jQuery(document).ready(function($) {

    $( ".bloc_etapes" ).each(function( index ) {

        $( ".bloc_etapes .etape" ).each(function( index ) {

            var parent = $(this)
            var visuel = parent.find(".visuel img")
            var compte = parent.find(".visuel .compte")

            gsap.from( visuel, {
                y : +300,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: parent,
                    markers: false,
                    start: "top 80%",
                    end: "top 30%",
                    scrub: 1,
                }

            })

            gsap.from( compte, {
                opacity : 0,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: parent,
                    markers: false,
                    start: "top 80%",
                    end: "top 30%",
                    scrub: 1,
                }

            })


        })


    })

});